import React, {
  createContext,
  useState,
  useCallback,
  useMemo,
  SetStateAction,
  Dispatch
} from 'react';
import { type Waypoint } from 'react-waypoint';

type ContextType = {
  handleStickyTransition: ({
    currentPosition,
    previousPosition
  }: Waypoint.CallbackArgs) => void;
  isStickySearchBar: boolean;
  setStickySearchBar: Dispatch<SetStateAction<boolean>>;
};

const defaultContext: ContextType = {
  handleStickyTransition() {},
  isStickySearchBar: false,
  setStickySearchBar() {}
};

export const StickySearchContext = createContext<ContextType>(defaultContext);

export default function StickySearchProvider({
  children
}: React.PropsWithChildren) {
  const [isStickySearchBar, setStickySearchBar] = useState(false);
  //car-merch-ui-srp-reskin this function will not be needed once we remove control code
  const handleStickyTransition = useCallback(
    ({ currentPosition, previousPosition }: Waypoint.CallbackArgs) => {
      if (currentPosition === 'above' && previousPosition === 'inside') {
        setStickySearchBar(true);
      }
      if (currentPosition === 'inside' && previousPosition === 'above') {
        setStickySearchBar(false);
      }
    },
    []
  );

  const value = useMemo(
    () => ({
      handleStickyTransition,
      isStickySearchBar,
      setStickySearchBar
    }),
    [handleStickyTransition, isStickySearchBar]
  );

  return (
    <StickySearchContext.Provider value={value}>
      {children}
    </StickySearchContext.Provider>
  );
}
